import * as React from 'react';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import DownloadApplication from 'src/pages/Permits/PetPermit/DownloadApplication';
import { Divider, Tooltip } from '@mui/material';
import DownloadForOfflineIcon from '@mui/icons-material/DownloadForOffline';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2)
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1)
  }
}));

export default function CustomizedDialogs({ ApplicationDetails, title }) {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <React.Fragment>
      <Tooltip title="Download Application">
        <IconButton size="large" color="primary" onClick={handleClickOpen}>
          <DownloadForOfflineIcon />
        </IconButton>
      </Tooltip>

      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        maxWidth={false} // Disable the predefined width options
        PaperProps={{
          sx: {
            width: '50%', // Set width to 70% of the screen
            maxWidth: '50%' // Set max width to 70% of the screen
          }
        }}
      >
        <DialogTitle id="customized-dialog-title">
          Download Application Form
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={(theme) => ({
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme.palette.grey[500]
          })}
        >
          <CloseIcon />
        </IconButton>
        <Divider />
        <DialogContent
          sx={{
            p: '0px !important'
          }}
        >
          <DownloadApplication
            ApplicationDetails={ApplicationDetails}
            title={title}
          />
          <br />
        </DialogContent>
      </BootstrapDialog>
    </React.Fragment>
  );
}
